import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Grid2,
  Box,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/system";
import axiosInstance from "../../../api/axiosConfig"; // Assuming axiosInstance is configured
import { useSession } from "../../../context/SessionContext";

const Item = styled(Box)(() => ({
  textAlign: "right",
}));

export default function ProfilePage() {
  const [profileData, setProfileData] = useState(null); // State for profile data
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling
  const { session } = useSession();

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const userId = session?.user?.id; // Get user ID from session
        const response = await axiosInstance.get(
          `/User/api/User/GetUserProfile`,
          {
            params: { Id: userId },
          },
        );
        // console.log(response.data, "sag23");
        setProfileData(response.data);
      } catch (err) {
        setError("خطا در دریافت اطلاعات کاربر");
      } finally {
        setLoading(false);
      }
    };

    if (session?.user?.id) {
      fetchProfileData();
    }
  }, [session]);

  if (loading) {
    return (
      <CircularProgress sx={{ display: "block", margin: "0 auto", mt: 4 }} />
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ textAlign: "center", mt: 4 }}>
        {error}
      </Typography>
    );
  }

  return (
    <Grid2
      container
      spacing={1}
      sx={{
        direction: "rtl",
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      {/* Header Section */}
      <Grid2 size={12}>
        <Item>
          <Grid2 container justifyContent="space-between" alignItems="center">
            <Grid2>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                اطلاعات شخصی
              </Typography>
            </Grid2>
            <Grid2>
              <Button variant="outlined" color="primary">
                ویرایش
              </Button>
            </Grid2>
          </Grid2>
        </Item>
      </Grid2>

      {/* Profile Details */}
      <Grid2 size={6}>
        <Item>
          <Typography>نام :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.fName || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>نام خانوادگی :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.lName || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>کد ملی :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.nationalCode || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>تاریخ تولد :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.birthday || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>شهر محل اقامت :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.baseCityName || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>روستا :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.villageName || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>آدرس :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.userAddress || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>کد پستی :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.postalCode || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>تخصص :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.baseSportFieldName || "-"}
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>درصد شنوایی گوش چپ :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.leftHearingPercentage || "0"}%
          </Typography>
        </Item>
      </Grid2>

      <Grid2 size={6}>
        <Item>
          <Typography>درصد شنوایی گوش راست :</Typography>
          <Typography sx={{ color: "#666", marginTop: 1 }}>
            {profileData?.rightHearingPercentage || "0"}%
          </Typography>
        </Item>
      </Grid2>
    </Grid2>
  );
}
